import { Link } from "wouter";

/**
 * Footer (build Appendix A11), plus Host FAQ, SMS Terms and About & Contact,
 * which Travis asked to keep (Oct 4; logged in docs/build/copy-changes.md).
 */
const PRODUCT_LINKS = [
  { label: "Features", href: "/features", testId: "features" },
  { label: "Pricing", href: "/pricing", testId: "pricing" },
  { label: "Property managers", href: "/property-managers", testId: "property-managers" },
  { label: "Free research", href: "/research", testId: "research" },
  { label: "Savings calculator", href: "/savings-calculator", testId: "savings-calculator" },
];

const SUPPORT_LINKS = [
  { label: "Host FAQ", href: "/faq/hosts", testId: "host-faq" },
  { label: "SMS Terms", href: "/terms#sms", testId: "sms-terms" },
];

const COMPANY_LINKS = [
  { label: "About & Contact", href: "/about", testId: "about" },
  { label: "Terms", href: "/terms", testId: "terms" },
  { label: "Privacy", href: "/privacy", testId: "privacy" },
];

function openSupportChat() {
  const crisp = (window as unknown as { $crisp?: unknown[] }).$crisp;
  if (Array.isArray(crisp)) crisp.push(["do", "chat:open"]);
  else window.location.href = "mailto:info@padpulse.io";
}

export function PublicFooter() {
  const linkClass = "hover:text-brand-accent transition-colors";
  return (
    <footer className="bg-gray-900 text-gray-300" data-testid="footer">
      <div className="container mx-auto px-6 py-12 lg:py-16">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-5 lg:gap-10">
          <div className="lg:col-span-2">
            <div className="mb-3 flex items-center gap-1">
              <span className="text-2xl font-bold text-white">Pad</span>
              <span className="text-2xl font-bold text-brand-accent">Pulse</span>
            </div>
            <p className="text-sm text-gray-400">for Hosts</p>
          </div>

          <div>
            <h2 className="mb-4 text-sm font-semibold uppercase tracking-wider text-white">Product</h2>
            <ul className="space-y-3 text-sm">
              {PRODUCT_LINKS.map((l) => (
                <li key={l.href}>
                  <Link href={l.href} className={linkClass} data-testid={`link-footer-${l.testId}`}>
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h2 className="mb-4 text-sm font-semibold uppercase tracking-wider text-white">Support</h2>
            <ul className="space-y-3 text-sm">
              <li>
                <button type="button" onClick={openSupportChat} className={linkClass} data-testid="button-footer-support">
                  Support
                </button>
              </li>
              {SUPPORT_LINKS.map((l) => (
                <li key={l.href}>
                  <Link href={l.href} className={linkClass} data-testid={`link-footer-${l.testId}`}>
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h2 className="mb-4 text-sm font-semibold uppercase tracking-wider text-white">Company</h2>
            <ul className="space-y-3 text-sm">
              <li>
                <Link href="/blog" className={linkClass} data-testid="link-footer-blog">
                  Blog
                </Link>
              </li>
              {COMPANY_LINKS.map((l) => (
                <li key={l.href}>
                  <Link href={l.href} className={linkClass} data-testid={`link-footer-${l.testId}`}>
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 border-t border-gray-800 pt-6">
          <p className="text-xs text-gray-400" data-testid="text-footer-bottom">
            © 2026 PadPulse LLC · PadPulse is independent software that connects to your PadSplit account.
          </p>
        </div>
      </div>
    </footer>
  );
}
